import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UseMutationResult } from 'react-query';
import type { OrganisationDto } from '../../../util/types/OrganisationDto';
import type { ApiResponse } from '../../../util/types/Response';

export function useServerOrganisationValidation<T>(
	newOrganisationMutation: UseMutationResult<
		ApiResponse<OrganisationDto>,
		unknown,
		void,
		unknown
	>,
	form: UseFormReturnType<T, (values: T) => T>,
) {
	useEffect(() => {
		if (!newOrganisationMutation.data?.isValid) {
			// biome-ignore lint/complexity/noForEach: <explanation>
			newOrganisationMutation.data?.validationMessages.forEach((v) => {
				if (v.inputIdentifier === 'ConnectionString') {
					form.setFieldError('connectionString', v.validationMessage);
				}
				if (v.inputIdentifier === 'Name') {
					form.setFieldError('name', v.validationMessage);
				}
				if (v.inputIdentifier === 'Username') {
					form.setFieldError('username', v.validationMessage);
				}
			});
		}
	}, [newOrganisationMutation.data?.validationMessages]);
}
